import React, { useState, useRef } from "react";

const SORT_OPTIONS = [
  { label: "Alphabetical", value: "alphabetical" },
  { label: "Relevance", value: "relevance" },
  { label: "Distance", value: "distance" },
];

export default function FilterSort({
  keywordFilter,
  setKeywordFilter,
  sortingOption,
  setSortingOption,
}) {
  const [sortingActive, setSortingActive] = useState(false);
  const [distanceDisabled, setDistanceDisabled] = useState(true);
  const comboMenuRef = useRef(null);

  return (
    <section className="section">
      <div className="content content--wide content--filters">
        <div className=" filterSort">
          <div className="filterSort-keyword">
            <label className="font-size-s bold">
              Find <span className="hidden-mobile">in results</span>
            </label>
            <input
              type="search"
              id="keyword-filter"
              name="keyword-filter"
              className="keyword-filter input"
              autoComplete="off"
              autoCorrect="off"
              value={keywordFilter}
              onChange={(event) => setKeywordFilter(event.target.value)}
            />
          </div>
          <div
            className={`filterSort-sorting combo ${sortingActive ? "open" : ""}`}
            onMouseLeave={() => setSortingActive(false)}
          >
            <div className="combo-label font-size-s">Sort by </div>
            <div
              aria-controls="listbox1"
              aria-expanded="false"
              aria-haspopup="listbox"
              aria-label="Sorting options"
              aria-labelledby="sorting"
              id="sorting"
              className="combo-input"
              role="combobox"
              tabIndex="0"
              onKeyDown={(event) => {
                if (event.key === "ArrowDown" || event.key === "Enter") {
                  event.preventDefault();
                  setSortingActive(true);
                  comboMenuRef?.current.firstChild.focus();
                }
              }}
              onClick={() => setSortingActive(!sortingActive)}
            >
              {sortingOption && SORT_OPTIONS.find((option) => option.value === sortingOption).label}
            </div>
            <div
              className={`combo-menu ${sortingActive ? "open" : ""}`}
              role="listbox"
              id="listbox1"
              aria-labelledby="sorting"
              ref={comboMenuRef}
            >
              {SORT_OPTIONS.map((option) => (
                <div
                  key={option.value}
                  className="font-size-s combo-menu-option"
                  role="option"
                  tabIndex={sortingActive ? 0 : -1}
                  onClick={() => {
                    setSortingOption(option.value);
                    setSortingActive(false);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      setSortingOption(option.value);
                      setSortingActive(false);
                    }

                    if (event.key === "ArrowDown") {
                      event.preventDefault();
                      if (event.target.nextSibling === null) {
                        event.target.parentNode.firstChild.focus();
                      } else {
                        event.target.nextSibling.focus();
                      }
                    }

                    if (event.key === "ArrowUp") {
                      event.preventDefault();

                      if (event.target.previousSibling === null) {
                        event.target.parentNode.lastChild.focus();
                      } else {
                        event.target.previousSibling.focus();
                      }
                    }

                    if (event.key === "Escape") {
                      setSortingActive(false);
                    }

                    if (event.key === "Tab") {
                      setSortingActive(false);
                    }
                  }}
                  data-value={option.value}
                >
                  {option.label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
